import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { customNumberFormat, formatBytes, getColorByProgress } from '../../functions/general'
import { useSettingsStore } from '../../stores/SettingsStore'
import useUser from '../../hooks/User'
import moment from "moment";
import RadialProgress from './RadialProgress'
import useCheckIsMobile from '../../hooks/useCheckIsMobile'
import IntlMessageFormat from 'intl-messageformat';
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import useAccessToken from '../../hooks/AccessToken'
import useSWR from 'swr'
import axios from 'axios'
import { CompanyLimit } from '../../interfaces/Company'
interface LimitWidthProgress {
    pipelineDatabase: number
    merchantDatabase: number
    meetingDatabase: number
    limitUser: number
    limitUserEmail: number
    limitComponentAnalytics: number
    limitMasterRoom: number
    limitAttendance: number
    limitSuccessPack: number
    limitDrive: number
}

interface InfoLimitDatabaseProps {
    data: CompanyLimit
    isLoadingCompanyLimitData: boolean
}

const InfoLimitDatabase = ({ data, isLoadingCompanyLimitData }: InfoLimitDatabaseProps) => {
    const intl = useIntl()
    const user = useUser()
    const token = useAccessToken()
    const { settings } = useSettingsStore()
    const { isMobile } = useCheckIsMobile()
    const [limitWidthProgress, setLimitWidthProgress] = useState<LimitWidthProgress>({
        pipelineDatabase: 0,
        merchantDatabase: 0,
        meetingDatabase: 0,
        limitUser: 0,
        limitUserEmail: 0,
        limitComponentAnalytics: 0,
        limitMasterRoom: 0,
        limitAttendance: 0,
        limitSuccessPack: 0,
        limitDrive: 0
    })

    const fetcherCorporate = (url: string) => axios.post(url, {}, {
        headers: {
            'X-Auth-token': user.data.companyCorporateToken
        }
    }).then(res => res.data.data)
    const { data: dataCorporate, isLoading: isLoadingCorporate } = useSWR(user.data.companyCorporateToken && user.data.companyCorporateToken !== null ? `https://apiw.looyal.id/wzcorp/verify_token` : null, fetcherCorporate, { shouldRetryOnError: false, revalidateOnFocus: false, revalidateOnReconnect: false })

    useEffect(() => {
        setLimitWidthProgress(prevState => ({
            ...prevState,
            pipelineDatabase: Math.round(data.companyUsagePipelineTemplate / (data.companyLimitPipelineTemplate) * 100),
            merchantDatabase: Math.round(data.companyUsageMerchantTemplate / (data.companyLimitMerchantTemplate) * 100),
            meetingDatabase: Math.round(data.companyUsageMeetingTemplate / (data.companyLimitMeetingTemplate) * 100),
            limitUser: Math.round(data.companyUsageUser / (data.companyLimitUser) * 100),
            limitUserEmail: Math.round(data.companyUsageMasterEmail / (data.companyLimitMasterEmail) * 100),
            limitComponentAnalytics: Math.round(data.companyUsageComponentAnalytic / (data.companyLimitComponentAnalytic) * 100),
            limitMasterRoom: Math.round(data.companyUsageMasterRoom / (data.companyLimitMasterRoom) * 100),
            limitAttendance: Math.round(data.companyUsageUserAttendance / (data.companyLimitUserAttendance) * 100),
            limitChat: Math.round(data.companyUsageChat / (data.companyLimitChat) * 100),
            limitSuccessPack: Math.round(data.companyUsageSuccessPack / (data.companyLimitSuccessPack) * 100),
            limitDrive: Math.round(Number(data.companyUsageDrive) / Number(data.companyLimitDrive) * 100)
        }))

        return () => {
            setLimitWidthProgress({
                pipelineDatabase: 0,
                merchantDatabase: 0,
                meetingDatabase: 0,
                limitUser: 0,
                limitUserEmail: 0,
                limitComponentAnalytics: 0,
                limitMasterRoom: 0,
                limitAttendance: 0,
                limitSuccessPack: 0,
                limitDrive: 0
            })
        }
    }, [data])

    const convertMinuteToHours = (minutes: number) => {
        const hours = Math.floor(minutes / 60)
        return intl.formatMessage({ id: "FORM.LABEL.HOURS" }, { hours: hours })
    }

    const handleRedirectDrive = () => {
        window.open(`https://drive.wooblazz.com/wzdrive/t/${btoa(token)}`, '_blank');
    }

    const handleRedirectCorporate = () => {
        window.open(`https://corporate.wooblazz.com/wzcorp/t/${user.data.companyCorporateToken}`, '_blank');
    }

    return (
        <>
            {
                !isLoadingCompanyLimitData ?
                    <div className="row">
                        <div className='col-lg-8 col-xl-9'>
                            <div className="card mb-5 mb-xl-10" >
                                <div className="card-header">
                                    <div className="card-title m-0">
                                        <h3 className="fw-bolder m-0">{intl.formatMessage({ id: "MENU.SUBSCRIPTION_INFO" })}</h3>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className='xl-px-9 d-grid gap-5' style={{ gridTemplateColumns: `${isMobile ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)'}` }}>
                                        {
                                            data.companyLimitUser > 0 && (
                                                <div className="d-flex align-items-center flex-column border border-gray-300 border-dashed rounded p-3">
                                                    <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                        <span className="fw-bold fs-6 text-gray-400">
                                                            {intl.formatMessage({ id: 'MENU.USERS' })}
                                                        </span>
                                                        <span className="fw-bolder fs-6">
                                                            {customNumberFormat(data.companyUsageUser)} / {customNumberFormat(data.companyLimitUser)}
                                                        </span>
                                                    </div>
                                                    <div className="h-5px mx-3 w-100 mb-3" style={{ backgroundColor: "#f5f8fa" }}>
                                                        <div className={`rounded h-5px`} role="progressbar" style={{ backgroundColor: `${getColorByProgress(limitWidthProgress.limitUser)}`, width: (limitWidthProgress.limitUser >= 100 ? 100 : limitWidthProgress.limitUser) + "%" }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                        {
                                            data.companyLimitMasterEmail > 0 && (
                                                <div className="d-flex align-items-center flex-column border border-gray-300 border-dashed rounded p-3">
                                                    <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                        <span className="fw-bold fs-6 text-gray-400">
                                                            {'Email'}
                                                        </span>
                                                        <span className="fw-bolder fs-6">
                                                            {customNumberFormat(data.companyUsageMasterEmail)} / {customNumberFormat(data.companyLimitMasterEmail)}
                                                        </span>
                                                    </div>
                                                    <div className="h-5px mx-3 w-100 mb-3" style={{ backgroundColor: "#f5f8fa" }}>
                                                        <div className={`rounded h-5px`} role="progressbar" style={{ backgroundColor: `${getColorByProgress(limitWidthProgress.limitUserEmail)}`, width: (limitWidthProgress.limitUserEmail >= 100 ? 100 : limitWidthProgress.limitUserEmail) + "%" }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                        {
                                            data.companyLimitComponentAnalytic > 0 && (
                                                <div className="d-flex align-items-center flex-column border border-gray-300 border-dashed rounded p-3">
                                                    <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                        <span className="fw-bold fs-6 text-gray-400">
                                                            {intl.formatMessage({ id: 'FORM.LABEL.COMPONENT_ANALYTIC' })}
                                                        </span>
                                                        <span className="fw-bolder fs-6">
                                                            {customNumberFormat(data.companyUsageComponentAnalytic)} / {customNumberFormat(data.companyLimitComponentAnalytic)}
                                                        </span>
                                                    </div>
                                                    <div className="h-5px mx-3 w-100 mb-3" style={{ backgroundColor: "#f5f8fa" }}>
                                                        <div className={`rounded h-5px`} role="progressbar" style={{ backgroundColor: `${getColorByProgress(limitWidthProgress.limitComponentAnalytics)}`, width: (limitWidthProgress.limitComponentAnalytics >= 100 ? 100 : limitWidthProgress.limitComponentAnalytics) + "%" }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                        {
                                            data.companyLimitUserAttendance > 0 && (
                                                <div className="d-flex align-items-center flex-column border border-gray-300 border-dashed rounded p-3">
                                                    <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                        <span className="fw-bold fs-6 text-gray-400">
                                                            {intl.formatMessage({ id: 'FORM.LABEL.ATTENDANCE_TEMPLATE_USERS' })}
                                                        </span>
                                                        <span className="fw-bolder fs-6">
                                                            {customNumberFormat(data.companyUsageUserAttendance)} / {customNumberFormat(data.companyLimitUserAttendance)}
                                                        </span>
                                                    </div>
                                                    <div className="h-5px mx-3 w-100 mb-3" style={{ backgroundColor: "#f5f8fa" }}>
                                                        <div className={`rounded h-5px`} role="progressbar" style={{ backgroundColor: `${getColorByProgress(limitWidthProgress.limitAttendance)}`, width: (limitWidthProgress.limitAttendance >= 100 ? 100 : limitWidthProgress.limitAttendance) + "%" }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                        {/* {
                                        data.companyLimitMasterRoom > 0 && (
                                            <div className="d-flex align-items-center flex-column border border-gray-300 border-dashed rounded p-3">
                                                <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                    <span className="fw-bold fs-6 text-gray-400">
                                                        {intl.formatMessage({ id: 'FORM.LABEL.CONFERENCE_ROOM' })}
                                                    </span>
                                                    <span className="fw-bolder fs-6">
                                                        {customNumberFormat(data.companyUsageMasterRoom)} / {customNumberFormat(data.companyLimitMasterRoom)}
                                                    </span>
                                                </div>
                                                <div className="h-5px mx-3 w-100 mb-3" style={{ backgroundColor: "#f5f8fa" }}>
                                                    <div className={`${getColorByProgress(limitWidthProgress.limitMasterRoom)} rounded h-5px`} role="progressbar" style={{ width: (limitWidthProgress.limitMasterRoom >= 100 ? 100 : limitWidthProgress.limitMasterRoom) + "%" }}>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    } */}

                                        {
                                            (data.companyLimitSuccessPack > 0 || data.companyUsageSuccessPack > 0) && (
                                                <div className="d-flex align-items-center flex-column border border-gray-300 border-dashed rounded p-3">
                                                    <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                        <span className="fw-bold fs-6 text-gray-400">
                                                            {'Success Pack'}
                                                        </span>
                                                        <span className="fw-bolder fs-6">
                                                            {convertMinuteToHours(parseInt(customNumberFormat(data.companyUsageSuccessPack)))} / {convertMinuteToHours(parseInt(customNumberFormat(data.companyLimitSuccessPack)))}
                                                        </span>
                                                    </div>
                                                    <div className="h-5px mx-3 w-100 mb-3" style={{ backgroundColor: "#f5f8fa" }}>
                                                        <div className={`rounded h-5px`} role="progressbar" style={{ backgroundColor: `${getColorByProgress(limitWidthProgress.limitSuccessPack)}`, width: (limitWidthProgress.limitSuccessPack >= 100 ? 100 : limitWidthProgress.limitSuccessPack) + "%" }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>

                                    <div className='py-9 xl-px-9 d-grid gap-5' style={{ gridTemplateColumns: `${isMobile ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)'}` }}>
                                        {data.companyLimitPipelineTemplate > 0 && (
                                            <div className="d-flex align-items-center flex-column border border-gray-300 border-dashed rounded p-3">
                                                <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                    <span className="fw-bold fs-6 text-gray-400">
                                                        {intl.formatMessage({ id: 'FORM.LABEL.TEMPLATE_TITLE' }, { title: settings.pipeline_title })}
                                                    </span>
                                                    <span className="fw-bolder fs-6">
                                                        {customNumberFormat(data.companyUsagePipelineTemplate)} / {customNumberFormat(data.companyLimitPipelineTemplate)}
                                                    </span>
                                                </div>
                                                <RadialProgress progress={limitWidthProgress.pipelineDatabase} color={getColorByProgress(limitWidthProgress.pipelineDatabase)} />
                                            </div>
                                        )}

                                        {
                                            data.companyLimitMerchantTemplate > 0 && (
                                                <div className="d-flex align-items-center flex-column border border-gray-300 border-dashed rounded p-3">
                                                    <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                        <span className="fw-bold fs-6 text-gray-400">
                                                            {intl.formatMessage({ id: 'FORM.LABEL.TEMPLATE_TITLE' }, { title: settings.merchant_title })}
                                                        </span>
                                                        <span className="fw-bolder fs-6">
                                                            {customNumberFormat(data.companyUsageMerchantTemplate)} / {customNumberFormat(data.companyLimitMerchantTemplate)}
                                                        </span>
                                                    </div>
                                                    <RadialProgress progress={limitWidthProgress.merchantDatabase} color={getColorByProgress(limitWidthProgress.merchantDatabase)} />
                                                </div>
                                            )
                                        }

                                        {
                                            data.companyLimitMeetingTemplate > 0 && (
                                                <div className="d-flex align-items-center flex-column border border-gray-300 border-dashed rounded p-3">
                                                    <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                        <span className="fw-bold fs-6 text-gray-400">
                                                            {intl.formatMessage({ id: 'FORM.LABEL.TEMPLATE_TITLE' }, { title: settings.meeting_title })}
                                                        </span>
                                                        <span className="fw-bolder fs-6">
                                                            {customNumberFormat(data.companyUsageMeetingTemplate)} / {customNumberFormat(data.companyLimitMeetingTemplate)}
                                                        </span>
                                                    </div>
                                                    <RadialProgress progress={limitWidthProgress.meetingDatabase} color={getColorByProgress(limitWidthProgress.meetingDatabase)} />
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div >
                        </div >

                        <div className='col-lg-4 col-xl-3'>
                            <div className="card mb-5 mb-xl-10" >
                                <div className="card-header">
                                    <div className="card-title m-0">
                                        <h3 className="fw-bolder m-0">{intl.formatMessage({ id: "MENU.MORE_PRODUCT_INFO" })}</h3>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className='xl-px-9 d-grid gap-5'>
                                        {
                                            (Number(data.companyLimitDrive) > 0) && (
                                                <div className="d-flex flex-column border border-gray-300 border-dashed rounded p-3">
                                                    <img src={toAbsoluteUrl('/media/logos/logo-wooblazz-drive.png')} alt="Logo Wooblazz Drive" style={{ width: "100px", padding: "10px" }} />
                                                    <span onClick={handleRedirectDrive} className="fw-bold fs-6 text-hover-primary cursor-pointer">
                                                        {'Wooblazz Drive'} <i className="fas fa-angle-right text-black"></i>
                                                    </span>
                                                    <span className="fw-bold text-muted fs-7 text-end">
                                                        {formatBytes(Number(data.companyUsageDrive))} / {formatBytes(Number(data.companyLimitDrive))}
                                                    </span>
                                                    <div className="h-5px w-100 mb-3" style={{ backgroundColor: "#f5f8fa" }}>
                                                        <div className={`rounded h-5px`} role="progressbar" style={{ backgroundColor: `${getColorByProgress(limitWidthProgress.limitDrive)}`, width: (limitWidthProgress.limitDrive >= 100 ? 100 : limitWidthProgress.limitDrive) + "%" }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            dataCorporate && !isLoadingCorporate && (
                                                <div className="d-flex flex-column border border-gray-300 border-dashed rounded p-3">
                                                    <img src={toAbsoluteUrl('/media/logos/logo-wooblazz-corp.png')} alt="Logo Wooblazz Drive" style={{ width: "100px", padding: "10px" }} />
                                                    <div className="w-100 mt-auto mb-2">
                                                        <span onClick={handleRedirectCorporate} className="fw-bold fs-6 text-hover-primary cursor-pointer">
                                                            {'Wooblazz Corporate'} <i className="fas fa-angle-right text-black"></i>
                                                        </span>
                                                        <div className='d-flex align-items-center fw-bold text-muted fs-7 mt-3'>
                                                            <KTSVG path='/media/icons/duotune/communication/com006.svg' className={`svg-icon-4 me-3`} />
                                                            {dataCorporate.user_name}
                                                        </div>
                                                        <div className='d-flex align-items-center fw-bold text-muted fs-7'>
                                                            <KTSVG path='/media/icons/duotune/general/gen014.svg' className={`svg-icon-4 me-3`} />
                                                            Exp. {moment(dataCorporate.user_expired).format('DD MMMM YYYY')}
                                                        </div>
                                                        <div className='d-flex align-items-center fw-bold text-muted fs-7'>
                                                            <KTSVG path='/media/icons/duotune/general/gen016.svg' className={`svg-icon-4 me-3`} />
                                                            {intl.formatMessage({ id: "FORM.LABEL.REMAINING_TOKENS" })} {customNumberFormat(dataCorporate.credit_list.reduce((total: number, credit: any) => total + credit.credit_full, 0) - dataCorporate.credit)}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div >
                        </div>
                    </div>
                    : (
                        <div className="loading-overlay">
                            <div className="loader"></div>
                        </div>
                    )
            }
        </>

    )
}

export default InfoLimitDatabase